import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-rating-star',
    templateUrl: './rating-star.component.html',
    styleUrls: ['./rating-star.component.scss']
})
export class RatingStarComponent implements OnInit {

@Input() rating: number;
  constructor() {
    this.rating = 0;
  }

  ngOnInit(): void {
  }

getStyleStar(value:number):string{
  if(this.rating>=value) return `fa fa-star`;
  return `fa fa-star-o`;
}

}
